<app-message-container
  [svgPath]="'payment_page.success.icon' | translate"
  [title]="'payment_page.success.title' | translate"
  [description]="'payment_page.success.description' | translate"
  [buttonText]="'payment_page.success.button_text' | translate"
  [routerPath]="'payment_page.success.url' | translate"
></app-message-container>

<app-bottom-image></app-bottom-image>